import { FC } from 'react'
import clsx from 'clsx'

import { WatchStatus } from 'constants/webinar-data'
import { TypeCodes } from 'constants/data'

import styles from './card-watch-status.module.scss'

interface ICardWatchStatus {
  status?: WatchStatus
  ArticleTypeId?: number
}

const defineStatus = (status?: WatchStatus, ArticleTypeId?: number) => {
  if (!status || status === WatchStatus.NONE) return ''
  if (status === WatchStatus.FINISH && ArticleTypeId === TypeCodes.ARTICLE) return 'Прочитано'
  if (status === WatchStatus.FINISH) return 'Просмотрено'
  if (status === WatchStatus.PENDING) return 'В процессе'

  return ''
}

const CardWatchStatus: FC<ICardWatchStatus> = ({ status, ArticleTypeId }) => {
  const statusToRender = defineStatus(status, ArticleTypeId)

  if (!statusToRender) return null

  return (
    <div
      className={clsx(styles.status, {
        [styles.green]: status === WatchStatus.FINISH,
        [styles.gray]: status === WatchStatus.PENDING,
      })}
    >
      {statusToRender}
    </div>
  )
}

export default CardWatchStatus
